// extracted by mini-css-extract-plugin
module.exports = {"carouselWrapper":"Carousel_carouselWrapper__dJUxz","zoomOut":"Carousel_zoomOut__VSwWS"};